import Svg, { Path, type SvgProps } from 'react-native-svg'

export function FreezeIcon(props: SvgProps) {
  return (
    <Svg width={24} height={24} viewBox="0 0 24 24" fill="none" {...props}>
      <Path
        d="M1.99951 11.9998H21.9995"
        stroke={props.color ?? 'white'}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M11.9995 1.99976V21.9998"
        stroke={props.color ?? 'white'}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M19.9995 15.9998L15.9995 11.9998L19.9995 7.99976"
        stroke={props.color ?? 'white'}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M3.99951 7.99976L7.99951 11.9998L3.99951 15.9998"
        stroke={props.color ?? 'white'}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M15.9995 3.99976L11.9995 7.99976L7.99951 3.99976"
        stroke={props.color ?? 'white'}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M7.99951 19.9998L11.9995 15.9998L15.9995 19.9998"
        stroke={props.color ?? 'white'}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  )
}
